/* eslint prefer-promise-reject-errors: 0 */ // --> OFF

import HTTPErrorWithBody from "./customErrors/HTTPErrorWithBody";
import HTTPError from "./customErrors/HTTPError";
import fetchWithTimeout from "./fetchWithTimeout";

export async function api(endpoint, { body, token, ...customConfig } = {}) {
  const headers = { "Content-Type": "application/json" };

  if (token) {
    headers.Authorization = `Basic ${token}`;
  }

  const config = {
    method: body ? "POST" : "GET",
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
    credentials: "include",
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  let data;
  try {
    const response = await fetchWithTimeout(endpoint, config);

    if (response?.status === 500) {
      throw new HTTPError(response.status, response.statusText);
    }

    data = await response.json();

    if (response.ok) {
      return data;
    }

    if (response.status >= 400 && response.status < 500) {
      throw new HTTPErrorWithBody(data, response.status, response.statusText);
    } else {
      throw new HTTPError(response.status, response.statusText);
    }
  } catch (err) {
    if (err instanceof HTTPErrorWithBody) {
      return Promise.reject({ body: err.body, httpStatus: err.httpStatus });
    }
    return Promise.reject(err);
  }
}

api.get = function (endpoint, customConfig = {}) {
  return api(endpoint, { ...customConfig, method: "GET" });
};

api.post = function (endpoint, body, customConfig = {}) {
  return api(endpoint, { ...customConfig, body });
};
